import React from 'react'
import * as StyledComponent from '../styles'
import IconDropdown from '../images/icon_dropdown_arrow.svg'

const CountryCodeSelector = (props, context) => <StyledComponent.CountryCodeSelector>
  <span className='selector-container'>
    <select
      className='selector'
      value={props.country_code}
      onChange={props.onChange}
    >
      {
        props.selectable_country_codes.map(country_code =>
          <option key={`option-${country_code}`} value={country_code}>
            { country_code }
          </option>)
      }
    </select>
    <img className='select-dropdown' src={IconDropdown} alt="" />
  </span>
</StyledComponent.CountryCodeSelector>

export default CountryCodeSelector



// WEBPACK FOOTER //
// ./src/components/CountryCodeSelector.js